import React, { useState, useRef, useEffect } from 'react';
import css from './LineTabs.module.scss';
import PropTypes from 'prop-types';

const LineTabs = ({children, fullWidth = false}) => {
  const [underlineStyle, setUnderlineStyle] = useState({});
  const tabsRef = useRef([]);

  // Only keep valid React elements (skip null/false from conditional rendering)
  const validChildren = React.Children.toArray(children).filter(child =>
    React.isValidElement(child)
  );

  // Find the active tab index for underline positioning
  const activeTabIndex = validChildren.findIndex(child => child.props.active);

  useEffect(() => {
    if (activeTabIndex >= 0 && tabsRef.current[activeTabIndex]) {
      const activeTab = tabsRef.current[activeTabIndex];
      const rect = activeTab.getBoundingClientRect();
      const parentRect = activeTab.parentElement.getBoundingClientRect();

      setUnderlineStyle({
        left: rect.left - parentRect.left,
        width: rect.width,
        transition: 'all 0.2s ease',
      });
    }
  }, [activeTabIndex, validChildren.length]);

  const childrenWithProps = validChildren.map((child, index) =>
    React.cloneElement(child, {
      ref: (el) => (tabsRef.current[index] = el),
    })
  );

  return (
    <div className={`${css.tabsWrapper} ${fullWidth ? css.fullWidth : ''}`}>
      <div className={css.tabs}>
        {childrenWithProps}
      </div>
      <div className={css.underline} style={underlineStyle} />
    </div>
  );
};

LineTabs.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool
};

export default LineTabs;
